import Vue from "vue";

export const getMenu = ({ dispatch }) => {
  Vue.http.get("api/v1/Menu").then(function (response) {
    dispatch("MENU_RECIEVED", response.data);
  });
};

export const getSearchTerms = ({ dispatch }) => {
  Vue.http.get("api/v1/Search").then(function (response) {
    dispatch("SEARCH_TERMS_LOADED", response.data);
  });
};

export const approveDisclaimer = ({ dispatch }) => {
  Vue.http.post("api/v1/Menu/Disclaimer").then(function (response) {
    dispatch("DISCLAIMER_APPROVED");
  });
};

export const goToHomePage = ({ dispatch }) => {
  dispatch("HOME_PAGE_LOADED");
};



// WEBPACK FOOTER //
// ./src/app/navigation/NavigationActions.js